import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "componentType", "listing", "onClick", "trackingProps"];
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { combineTrackingProps } from '../../utils/trackingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export function MarketplaceCardClickable(_ref) {
  let {
      children,
      componentType,
      listing,
      onClick,
      trackingProps
    } = _ref,
    clickableProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  return /*#__PURE__*/_jsx(Clickable, Object.assign({
    tagName: "div",
    disabled: !onClick,
    role: onClick ? undefined : 'none',
    onClick: () => {
      if (!onClick) return;
      trackMarketplaceEvent(getSearchResultClickedEvent(combineTrackingProps({
        componentType,
        listing,
        trackingProps
      })));
      onClick();
    }
  }, clickableProps, {
    children: children
  }));
}